import { render, staticRenderFns } from "./UpdateAdminPassword.vue?vue&type=template&id=2ec49b2b&scoped=true&"
import script from "./UpdateAdminPassword.vue?vue&type=script&lang=js&"
export * from "./UpdateAdminPassword.vue?vue&type=script&lang=js&"
import style0 from "./UpdateAdminPassword.vue?vue&type=style&index=0&id=2ec49b2b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec49b2b",
  null
  
)

export default component.exports